import { PROJECT_NAME } from 'containers/App/constants';

const CONTAINER_NAME = 'Customer';

export const GET_CUSTOMERS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMERS`;
export const GET_CUSTOMERS_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMERS_SUCCESS`;
export const GET_CUSTOMERS_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMERS_FAIL`;

export const GET_CUSTOMER = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER`;
export const GET_CUSTOMER_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_SUCCESS`;
export const GET_CUSTOMER_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_FAIL`;

export const GET_CUSTOMER_VOUCHERS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_VOUCHERS`;
export const GET_CUSTOMER_VOUCHERS_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_VOUCHERS_SUCCESS`;
export const GET_CUSTOMER_VOUCHERS_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_VOUCHERS_FAIL`;

export const GET_CUSTOMER_VOUCHERS_PENDING_REQUEST = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_VOUCHERS_PENDING_REQUEST`;
export const GET_CUSTOMER_VOUCHERS_PENDING_REQUEST_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_VOUCHERS_PENDING_REQUEST_SUCCESS`;
export const GET_CUSTOMER_VOUCHERS_PENDING_REQUEST_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_VOUCHERS_PENDING_REQUEST_FAIL`;

export const GET_CUSTOMER_GAME_TRANSACTIONS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_GAME_TRANSACTIONS`;
export const GET_CUSTOMER_GAME_TRANSACTIONS_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_GAME_TRANSACTIONS_SUCCESS`;
export const GET_CUSTOMER_GAME_TRANSACTIONS_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_GAME_TRANSACTIONS_FAIL`;

export const GET_CUSTOMER_PENDING_GAME_TRANSACTIONS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_PENDING_GAME_TRANSACTIONS`;
export const GET_CUSTOMER_PENDING_GAME_TRANSACTIONS_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_PENDING_GAME_TRANSACTIONS_SUCCESS`;
export const GET_CUSTOMER_PENDING_GAME_TRANSACTIONS_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CUSTOMER_PENDING_GAME_TRANSACTIONS_FAIL`;

export const UPDATE_CUSTOMER = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_CUSTOMER`;
export const UPDATE_CUSTOMER_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_CUSTOMER_SUCCESS`;
export const UPDATE_CUSTOMER_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_CUSTOMER_FAIL`;

export const SEARCH_CUSTOMER = `${PROJECT_NAME}/${CONTAINER_NAME}/SEARCH_CUSTOMER`;
export const SEARCH_CUSTOMER_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/SEARCH_CUSTOMER_SUCCESS`;
export const SEARCH_CUSTOMER_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/SEARCH_CUSTOMER_FAIL`;

export const ACTIVATE_CUSTOMER = `${PROJECT_NAME}/${CONTAINER_NAME}/ACTIVATE_CUSTOMER`;
export const ACTIVATE_CUSTOMER_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/ACTIVATE_CUSTOMER_SUCCESS`;
export const ACTIVATE_CUSTOMER_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/ACTIVATE_CUSTOMER_FAIL`;

export const DEACTIVATE_CUSTOMER = `${PROJECT_NAME}/${CONTAINER_NAME}/DEACTIVATE_CUSTOMER`;
export const DEACTIVATE_CUSTOMER_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/DEACTIVATE_CUSTOMER_SUCCESS`;
export const DEACTIVATE_CUSTOMER_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/DEACTIVATE_CUSTOMER_FAIL`;

export const DELETE_CUSTOMER = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_CUSTOMER`;
export const DELETE_CUSTOMER_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_CUSTOMER_SUCCESS`;
export const DELETE_CUSTOMER_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_CUSTOMER_FAIL`;

// The customer listing, and the destination both customer screens head back to. `list` rather than
// the bare `/p/customers` the route table redirects from, so the return costs no second navigation.
export const CUSTOMERS_LIST_PATH = '/p/customers/list';

// The words the customer detail heading opens with, and the span that links back to the listing.
// Named so the heading and its link can never state them differently. The Customer 360 page draws
// the same heading from its own i18n copy. PLA-8844.
export const CUSTOMER_360_HEADING_LABEL = 'Customer 360';

// The approved helper text for the disabled 360 Intelligence switch (FR v12, Customer Detail access
// matrix).
export const CUSTOMER_360_NO_PERMISSION =
  "You don't have permission to view Customer 360 Intelligence.";
